import { render, staticRenderFns } from "./advStory.vue?vue&type=template&id=e23f4ca2"
import script from "./advStory.vue?vue&type=script&lang=js"
export * from "./advStory.vue?vue&type=script&lang=js"
import style0 from "./advStory.vue?vue&type=style&index=0&id=e23f4ca2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports